import { applicationError } from '@americanexpress/one-app-ducks';
import { getLoginUrl, isRedirecting } from './selectors';
import { queryUserSession } from './procedures';
import { redirectUsing } from './core';
import { MODULE_NAME } from './constants';

export const sanitize = ({ pathname: path = '/', search = '' }) => ({
  pathname: path.toLowerCase(),
  search,
});

const urlSelector = (getState) => {
  const entryPointData = localStorage.getItem('entryPointData');
  return entryPointData ? JSON.parse(entryPointData).entryURLNoSearch : getLoginUrl(getState());
};

const redirectToLogin = (router) => (dispatch, getState) => {
  const { pathname, search } = sanitize(router.location);
  const loginUrl = urlSelector(getState);
  if (!isRedirecting(getState()) && pathname.indexOf(loginUrl) === -1) {
    dispatch(redirectUsing(
      router.replace, `${loginUrl}?target=${encodeURIComponent(`${pathname}${search}`)}`, router.location
    ));
  }
};

const redirectToError = (error, router) => (dispatch, getState) => {
  const { pathname } = sanitize(router.location);
  if (isRedirecting(getState()) || pathname.indexOf('/error') !== -1) {
    return;
  }
  dispatch(applicationError(
    String(error.status), error, { moduleID: MODULE_NAME }
  ));
  dispatch(redirectUsing(router.replace, `${pathname.replace(/\/+$/, '')}/error`, router.location));
};

const requireLogin = (router) => (dispatch) => {
  const {
    data: queryResult,
    error: queryError,
    promise,
  } = dispatch(queryUserSession());

  if (queryResult?.status === 200) {
    return {
      status: 'complete',
      data: true,
    };
  }

  // There are three potential sources of errors:
  // - Thrown during the iguazu lifecycle
  // - Thrown during the iguazu-rpc lifecycle
  // - Returned from the ReadUserStatus procedure call
  let error = queryError;
  if (queryResult instanceof Error) {
    error = queryResult;
  } else if (queryResult && queryResult.status !== 200) {
    const { errorCode, description } = queryResult.data;
    error = Object.assign(
      new Error(`${errorCode}: ${description}`),
      { status: queryResult.status }
    );
  }
  if (error) {
    error.status = error.status || 500;
    if (error.status === 401
        || (error.status === 400 && error.message.startsWith('IDENT01'))) {
      dispatch(redirectToLogin(router));
    } else {
      dispatch(redirectToError(error, router));
    }

    return {
      status: 'complete',
      data: false,
      error,
    };
  }

  return {
    status: 'loading',
    promise,
  };
};

export default requireLogin;
